var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "meta-insights-overview" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title-block" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("metaInsights.overviewTitle"))),
        ]),
        _vm._v(" "),
        _vm.adAccount
          ? _c("div", { staticClass: "subtitle" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.adAccount.name) +
                  "\n                "
              ),
              _c("span", { staticClass: "muted" }, [
                _vm._v("(" + _vm._s(_vm.adAccount.id) + ")"),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "toolbar" },
        [
          _c("DateRangePicker", {
            on: { change: _vm.onDateRangeChange },
            model: {
              value: _vm.dateRange,
              callback: function ($$v) {
                _vm.dateRange = $$v
              },
              expression: "dateRange",
            },
          }),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              attrs: { ghost: "", disabled: _vm.loading },
              on: { click: _vm.loadAll },
            },
            [
              _c(
                "i",
                {
                  staticClass: "material-icons",
                  class: { spinning: _vm.loading },
                },
                [_vm._v("refresh")]
              ),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("metaInsights.refresh")) +
                  "\n            "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.adAccount
      ? _c("div", { staticClass: "info-banner" }, [
          _c("div", { staticClass: "info-item" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("flag")]),
            _vm._v(" "),
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("metaInsights.banner.status"))),
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "value", class: _vm.accountStatusClass },
              [_vm._v(_vm._s(_vm.accountStatusLabel))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("paid")]),
            _vm._v(" "),
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("metaInsights.banner.currency"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.adAccount.currency || "-")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("schedule")]),
            _vm._v(" "),
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("metaInsights.banner.timezone"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.adAccount.timezone_name || "-")),
            ]),
          ]),
          _vm._v(" "),
          _vm.adAccount.business && _vm.adAccount.business.name
            ? _c("div", { staticClass: "info-item" }, [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("business"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("metaInsights.banner.business"))),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.adAccount.business.name)),
                ]),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "section" },
      [
        _c("InsightsKpiCards", {
          attrs: {
            insights: _vm.summary,
            currency: _vm.currency,
            loading: _vm.loadingSummary,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "section" },
      [
        _c("div", { staticClass: "section-title" }, [
          _vm._v(_vm._s(_vm.$t("metaInsights.dailyTrend"))),
        ]),
        _vm._v(" "),
        _vm.trendSeries && _vm.trendSeries.length > 0
          ? _c(
              "div",
              { staticClass: "chart-wrapper" },
              [
                _c("ECharts", {
                  staticClass: "echart-graph",
                  attrs: { option: _vm.chartOption },
                }),
              ],
              1
            )
          : !_vm.loadingTrend
          ? _c("div", { staticClass: "chart-empty" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("metaInsights.noTrendData")) +
                  "\n        "
              ),
            ])
          : _c("a-skeleton", { attrs: { active: true } }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "section" },
      [
        _c("div", { staticClass: "section-title-row" }, [
          _c("div", { staticClass: "section-title" }, [
            _vm._v(_vm._s(_vm.$t("metaInsights.topCampaigns"))),
          ]),
          _vm._v(" "),
          _c("a", { on: { click: _vm.goToCampaigns } }, [
            _vm._v(_vm._s(_vm.$t("metaInsights.seeAll"))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "a-spin",
          { attrs: { spinning: _vm.loadingCampaigns } },
          [
            _c("InsightsTable", {
              attrs: {
                rows: _vm.topCampaigns,
                currency: _vm.currency,
                clickable: true,
                "table-id": "overview-top-campaigns",
                "name-label-key": "metaInsights.col.campaignName",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "section" },
      [
        _c("div", { staticClass: "section-title-row" }, [
          _c("div", { staticClass: "section-title" }, [
            _vm._v(_vm._s(_vm.$t("metaInsights.topAds"))),
          ]),
          _vm._v(" "),
          _c("a", { on: { click: _vm.goToAds } }, [
            _vm._v(_vm._s(_vm.$t("metaInsights.seeAll"))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "a-spin",
          { attrs: { spinning: _vm.loadingAds } },
          [
            _c("InsightsTable", {
              attrs: {
                rows: _vm.topAds,
                currency: _vm.currency,
                clickable: false,
                "show-creative": true,
                "table-id": "overview-top-ads",
                "name-label-key": "metaInsights.col.adName",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "section" }, [
      _c("div", { staticClass: "section-title" }, [
        _vm._v(_vm._s(_vm.$t("metaInsights.actionsTitle"))),
      ]),
      _vm._v(" "),
      _vm.actionsRows && _vm.actionsRows.length > 0
        ? _c(
            "div",
            { staticClass: "actions-grid" },
            _vm._l(_vm.actionsRows, function (row) {
              return _c("div", { key: row.type, staticClass: "action-card" }, [
                _c("div", { staticClass: "action-label" }, [
                  _vm._v(_vm._s(_vm.actionLabel(row.type))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "action-value" }, [
                  _vm._v(_vm._s(_vm.formatNumber(row.value))),
                ]),
                _vm._v(" "),
                row.costPerAction != null
                  ? _c("div", { staticClass: "action-cost" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.formatCurrency(row.costPerAction, _vm.currency)
                          ) +
                          "\n                    "
                      ),
                      _c("span", { staticClass: "muted" }, [
                        _vm._v("/ " + _vm._s(_vm.$t("metaInsights.perAction"))),
                      ]),
                    ])
                  : _vm._e(),
              ])
            }),
            0
          )
        : !_vm.loadingSummary
        ? _c("div", { staticClass: "empty-line" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("metaInsights.noActions")) +
                "\n        "
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }